import { render, staticRenderFns } from "./StartSuccess.vue?vue&type=template&id=15416220&scoped=true"
import script from "./StartSuccess.vue?vue&type=script&lang=js"
export * from "./StartSuccess.vue?vue&type=script&lang=js"
import style0 from "./StartSuccess.vue?vue&type=style&index=0&id=15416220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15416220",
  null
  
)

export default component.exports